export default __webpack_public_path__ + "static/media/02designtouchpoint.7cb775d0.jpg";